import { UwBRLocationReview } from '../../../../../types/underwriting.type';

export const getConstructionStageString = (locationReviews: UwBRLocationReview[]) => {
    const isMidTermPlacement = locationReviews.some((lr: UwBRLocationReview) => !!lr.midTermPlacement);
    const isRenovation = locationReviews.some((lr: UwBRLocationReview) => !!lr.renovationModifier);
    return `${isRenovation ? 'Renovation' : 'New Construction'}${
        isMidTermPlacement ? ' - Mid Term Placement' : ' - Beginning of Term'
    }`;
};
